var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"ad0eb6c0bd8bcb85b2efd476af8d17668337ce2e"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["signalist@signalist"]={id:"ad0eb6c0bd8bcb85b2efd476af8d17668337ce2e"};
      